module.exports = __webpack_public_path__ + "static/img/Cock-Rings-nav-tile-900x1200.9577393.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/fenlei/Cock-Rings-nav-tile-900x1200.jpg
// module id = WRRB
// module chunks = 0